import React, { Component } from 'react';
import TrackVisibility from 'react-on-screen';
import PropTypes from 'prop-types';

import urlName from '../url-name';
import ListItem from './list-item';
import styles from '../scss/index.scss';
import { replaceState, setPageTitle } from './helpers';

/*
 * This is an Entry List. It displays a set amount of data
 * initially and will render more as the user scrolls.
 *
 * @prop elements - the array of elements to render in the list
 * @prop filter (optional) - the sector to exclusively show elements for
 * @prop sort (optional) - the type and direction to sort the elements
 */
export default class EntryList extends Component {

	state = {
		triggeredPeople: []
	}
	/*
	 * This filters the list of elements, currently supports:
	 *  - filtering people by sector
	 */
	filterElements(elements) {
		const { filter } = this.props;

		const filteredElements = filter && elements.filter((element) => {
			const { sector } = element.fields;
			return sector && sector === filter;
		});

		return filteredElements || elements;
	}

	/*
	 * This arranges the elements for rendering
	 *  - removes priorityElement and places at front
	 *  - filters elements based on category
	 */
	arrangeElements(elements) {
		const { filter, priorityElementID } = this.props;

		// Find it in the array and remove it
		let priorityElement;
		elements = elements.filter((element) => {
			const { sector } = element.fields;
			const { id } = element.sys;
			const isPriorityElement = (id === priorityElementID);
			const isInCategory = !filter || (sector === filter);

			if (isPriorityElement) {
				priorityElement = element;
				return false;
			} else {
				return isInCategory;
			}
		});

		// Insert it at the front
		elements.unshift(priorityElement);

		return elements;
	}

	/*
	 * This sorts and renders the elements in the list, including
	 * the priority element at the top of the list, if it exists.
	 *
	 * Some of the Array methods used may not be supported across
	 * all browsers, so subject to change.
	 */
	renderElements() {
		const { priorityElementID, twitterData } = this.props;
		const { elements } = this.props;

		const filteredElements = this.filterElements(elements);

		let sortedElements = filteredElements.sort((a, b) => {
			return a.fields.rank - b.fields.rank;
		});

		if (priorityElementID) {
			sortedElements = this.arrangeElements(sortedElements);
		}

		let twitterEntry;
		return sortedElements.map((element, i) => {
			twitterEntry = twitterData[element.fields.twitterAccount];
			return this.renderElement(element, twitterEntry, i);
		});
	}

	/*
	 * This renders a single list element.
	 *
	 * @param element - the data for the list element
	 * @param twitterData - the twitter data for the element
	 * @param key - the unique key for rendering the element
	 */
	renderElement(element, twitterData, index) {
		const { focusedElementID, priorityElementID } = this.props;
		const { focusElement, ga } = this.props;
		const isPriority = priorityElementID && (element.sys.id === priorityElementID);
		const isFocused = focusedElementID && (element.sys.id === focusedElementID);
		const nameHash = urlName(element.fields.name);

		const itemProps = {
			element,
			focusElement,
			ga,
			isFocused,
			isPriority,
			nameHash,
			index,
			onItemInViewport: name => {
				replaceState(`/${name}/`);
				setPageTitle(element.fields.name);
			},
			twitterData
		};

		return (
			<TrackVisibility offset={-window.innerHeight / 2} partialVisibility key={index} throttleInterval={1000}>
				<ListItem {...itemProps} />
			</TrackVisibility>
		);
	}

	render() {
		return (
			<div className={styles.listContainer} id='list'>
				{this.renderElements()}
			</div>
		);
	}
}

EntryList.propTypes = {
	elements: PropTypes.array.isRequired,
	filter: PropTypes.string,
	focusedElementID: PropTypes.string,
	twitterData: PropTypes.object,
	priorityElementID: PropTypes.string
};



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/components/entry-list.js